module.exports = __webpack_public_path__ + "img/RA-Logo.1c580db1.png";